import React, { useState } from "react";
import BackIcon from "@styles/all-images/icons/back-button.svg";
import CheckWhiteIcon from "@styles/all-images/icons/checkwhite.svg";
import CloseBlueIcon from "@styles/all-images/icons/closeblue.svg";
import EyeIcon from "@styles/all-images/icons/view-icon.svg";
import ViewTermsSheetModal from "./ViewTermsSheetModal";
import TierConfigurationRejectionReason from "./TierConfigurationRejectionReason";

const TierConfigurationModule = () => {
  const [isViewTermsSheetModalOpen, setIsViewTermsSheetModalOpen] =
    useState(false);
  const [isTermsSheetOpen, setIsTermsSheetOpen] = useState(false);
  const [isRejectionModalOpen, setIsRejectionModalOpen] = useState(false);

  const handleViewTermsSheet = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsTermsSheetOpen(true);
  };

  const handleOpenRejectionModal = () => {
    setIsRejectionModalOpen(true);
  };

  const handleCloseTermsSheet = () => {
    setIsTermsSheetOpen(false);
  };

  const handleCloseRejectionModal = () => {
    setIsRejectionModalOpen(false);
  };

  const handleRejectionSubmit = () => {
    setIsRejectionModalOpen(false);
  };

  return (
    <div className="tw-relative">
      <div className="tw-fixed tw-h-[68px] tw-top-[80px] tw-w-full tw-z-10">
        <div className="tw-px-8 tw-py-4 tw-bg-white tw-border-b tw-border-[#E9EAEB]">
          <div className="tw-flex tw-justify-between tw-items-center">
            <div className="tw-flex tw-items-center">
              <a href="/tier-configuration">
                <img src={BackIcon} alt="Back Icon" />
              </a>
              <h1 className="tw-text-[22px] tw-ml-4 tw-font-semibold tw-text-[#232323]">
                Stakeholder Configuration Details
              </h1>
            </div>
            <div className="tw-flex tw-space-x-4">
              <button
                onClick={handleOpenRejectionModal}
                className="tw-flex-1 tw-px-4 tw-py-2 tw-border tw-flex tw-items-center tw-gap-2 tw-font-semibold
               tw-border-[#146C94] tw-rounded-lg tw-w-[50%] tw-text-center tw-text-base tw-text-[#146C94]"
              >
                Reject
                <img
                  src={CloseBlueIcon}
                  alt="Plus Icon"
                  className="tw-w-6 tw-h-6 tw-min-w-6 tw-min-h-6 tw-max-w-6 tw-max-h-6"
                />
              </button>
              <button
                className="tw-bg-blue-600 hover:tw-bg-blue-700 tw-flex tw-items-center tw-gap-2
               tw-text-white tw-rounded-md tw-px-4 tw-py-2 primary-custom-button"
              >
                Approve
                <img
                  src={CheckWhiteIcon}
                  alt="Plus Icon"
                  className="tw-w-6 tw-h-6 tw-min-w-6 tw-min-h-6 tw-max-w-6 tw-max-h-6"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Main Content */}
      <div className="tw-p-6 tw-mt-[147px] tw-gap-6 tw-flex-col tw-flex">
        <div className="tw-bg-[#ffffff] tw-rounded-2xl tw-shadow-md tw-border tw-border-[#E9EAEB]">
          <div className="tw-flex tw-justify-between tw-items-center tw-p-4">
            <h2 className="tw-text-base tw-font-semibold">Basic Details</h2>
          </div>
          <hr />
          <div className="tw-grid md:tw-grid-cols-3 sm:tw-grid-cols-12 tw-grid-cols-12 tw-gap-8 tw-p-8">
            <div className="tw-flex tw-flex-col tw-gap-1">
              <span className="tw-text-sm tw-font-medium tw-text-[#809199]">
                Super Trader (T4)
              </span>
              <h4 className="tw-text-base tw-text-[#232323] tw-font-semibold">
                Mark Robinson
              </h4>
            </div>
            <div className="tw-flex tw-flex-col tw-gap-1">
              <span className="tw-text-sm tw-font-medium tw-text-[#809199] ">
                TS Document (Shared by the bank user - T1)
              </span>
              <h4 className="tw-text-base tw-text-[#232323] tw-font-semibold tw-flex tw-items-center tw-gap-2">
                Terms Sheet Document 1
                <button onClick={handleViewTermsSheet}>
                  <img src={EyeIcon} alt="Eye Icon" />
                </button>
              </h4>
            </div>
            <div className="tw-flex tw-flex-col tw-gap-1">
              <span className="tw-text-sm tw-font-medium tw-text-[#809199]">
                Created By
              </span>
              <h4 className="tw-text-base tw-text-[#232323] tw-font-semibold">
                Anele Ndlovu
              </h4>
            </div>
            <div className="tw-flex tw-flex-col tw-gap-1">
              <span className="tw-text-sm tw-font-medium tw-text-[#809199]">
                Created on Date & Time
              </span>
              <h4 className="tw-text-base tw-text-[#232323] tw-font-semibold">
                03/12/2024 09:30
              </h4>
            </div>
            <div className="tw-flex tw-flex-col tw-gap-1">
              <span className="tw-text-sm tw-font-medium tw-text-[#809199]">
                Approval Status
              </span>
              <span className="tw-px-2 tw-py-1 tw-flex tw-items-center tw-gap-2 tw-rounded-full tw-text-sm tw-w-fit tw-bg-[#F5F5F5] tw-text-[#414651]">
                <span className="tw-w-2 tw-h-2 tw-rounded-full tw-bg-[#414651]"></span>
                Pending
              </span>
              <span className="tw-px-2 tw-py-1 tw-flex tw-items-center tw-gap-2 tw-rounded-full tw-text-sm tw-w-fit tw-bg-[#ECFDF3] tw-text-[#027A48]">
                <span className="tw-w-2 tw-h-2 tw-rounded-full tw-bg-[#027A48]"></span>
                Approved
              </span>
              <span className="tw-px-2 tw-py-1 tw-flex tw-items-center tw-gap-2 tw-rounded-full tw-text-sm tw-w-fit tw-bg-[#FDD4D2] tw-text-[#B54708]">
                <span className="tw-w-2 tw-h-2 tw-rounded-full tw-bg-[#B54708]"></span>
                Rejected
              </span>
            </div>
          </div>
        </div>
        <div className="tw-bg-[#ffffff] tw-rounded-2xl tw-shadow-md tw-border tw-border-[#E9EAEB]">
          <div className="tw-flex tw-justify-between tw-items-center tw-p-4">
            <h2 className="tw-text-base tw-font-semibold">
              Companies associated with the T4 user
            </h2>
          </div>
          <hr />
          <div className="tw-grid md:tw-grid-cols-3 sm:tw-grid-cols-12 tw-grid-cols-12 tw-gap-8 tw-p-8">
            <div className="tw-flex tw-flex-col tw-gap-1">
              <span className="tw-text-sm tw-font-medium tw-text-[#809199]">
                Funders/ Credit Providers (T1)
              </span>
              <h4 className="tw-text-base tw-text-[#232323] tw-font-semibold">
                GreenTech Solutions
              </h4>
            </div>
            <div className="tw-flex tw-flex-col tw-gap-1">
              <span className="tw-text-sm tw-font-medium tw-text-[#809199]">
                Insurance/ Guarantors (T2)
              </span>
              <h4 className="tw-text-base tw-text-[#232323] tw-font-semibold">
                SolarBright Energy
              </h4>
            </div>
            <div className="tw-flex tw-flex-col tw-gap-1">
              <span className="tw-text-sm tw-font-medium tw-text-[#809199]">
                Consultants/ Brokers (T6)
              </span>
              <h4 className="tw-text-base tw-text-[#232323] tw-font-semibold">
                EcoBuild Industries
              </h4>
            </div>
            <div className="tw-flex tw-flex-col tw-gap-1">
              <span className="tw-text-sm tw-font-medium tw-text-[#809199]">
                Commodity Suppliers (T7)
              </span>
              <h4 className="tw-text-base tw-text-[#232323] tw-font-semibold">
                BlueSky Logistics
              </h4>
            </div>
          </div>
        </div>
        {isViewTermsSheetModalOpen && (
          <ViewTermsSheetModal
            onClose={() => setIsViewTermsSheetModalOpen(true)}
          />
        )}
        {isTermsSheetOpen && (
          <ViewTermsSheetModal onClose={handleCloseTermsSheet} />
        )}

        <div>
          {isRejectionModalOpen && (
            <TierConfigurationRejectionReason
              onClose={handleCloseRejectionModal}
              onSubmit={handleRejectionSubmit}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TierConfigurationModule;
